<template>
	<div :class="$style['team-slide-wrap']">
		<TeamImage :img-src="thumbnailImgSrc" :img-hover-src="thumbnailImgHoverSrc" :scroll-animation-delay="index*.23"/>
		<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_SECONDARY_LARGE"
		                 :text-color="$const.HTML_CLASS.TEXT_COLOR.DARK"
		                 :scroll-animation-delay="index*.23">{{ name }}
		</rr-animate-text>
		<rr-animate-text :text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL"
		                 :text-color="$const.HTML_CLASS.TEXT_COLOR.DARK"
		                 :scroll-animation-delay="index*.23">{{ position }}
		</rr-animate-text>
	</div>
</template>

<script>
import TeamImage from './TeamImage'

export default {
	name: 'TeamSlideContent',
	components: {TeamImage},
	// data() {
	// 	return {
	// 	}
	// },
	props: {
		index: Number,
		thumbnailImgSrc: String,
		thumbnailImgHoverSrc: String,
		name: String,
		position: String,
	},
}
</script>

<style module lang="scss">
.team-slide-wrap {
	width: responsive-size-width-screen(450);
	// thumbnail
	picture {
		@include space-responsive-margin-b(27);
		// mobile
		@include breakpoint($mobileDesignBreakpoint) {
			margin-bottom: 15px;
		}
	}
}
</style>
